export default {
  "company": "Company",
  "person": "Contact",
  "invoice": "Invoice",
  api: {
    entity: {
      notFound: "Could not find {{entityType}}",
    },
    entityId: {
      notNull: "Something went wrong, unknown entity",
    },
  },
}
